module.exports = __webpack_public_path__ + "files/50145685042b4df07a1fd19957275b81.ttf";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/open-sans-v13-latin-ext_latin_cyrillic-ext_greek-ext_greek_cyrillic_vietnamese-700.ttf
// module id = 870
// module chunks = 60